// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import curriculum from './routes/curriculum';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  curriculum,
});

document.addEventListener('DOMContentLoaded', function() {
  routes.loadEvents()
});



// WEBPACK FOOTER //
// ./scripts/main.js